import './inc/Plugin';
import { MODE_LABELS } from './inc/ProductButtonMode'

/**
 * USAGE:
 *
 * $(document).ready(function() {
 *   $('body').productButtons();
 * });
 *
 * $('body').productButtons({
 *    selector: '.custom-colibri-product-button'
 * });
 */
( function( $ ) {
	'use strict';

	// Set up event handlers for the plugin

	$( document ).ready( () => {
		// Initialize the plugin and get the methods object
		const buttons = $( 'body' ).colibriProductButtons( {
			labels: MODE_LABELS
		} );

		// Set up event handlers using the exposed methods
		$( window )
			.on( 'popstate', () => buttons.init() )
			.on( 'ColibriEvent:INIT_ADD_TO_CART', buttons.initAddToCart )
			.on( 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', buttons.initAllAddToCarts )
			.on( 'ColibriEvent:UNINDEX_ADD_TO_CART', buttons.unindexAddToCart );
	} );
} )( jQuery );
